/**
 * Created by yibrahim on 19/07/2017.
 */
import {TravelCreditType} from "./travel-credit-type";
import {Iata} from "./iata";
import {ReasonCode} from "./reason-code";
import {RefundReason} from "./refund-reason";
import {Currency} from "./currency";
import {Team} from "./team";
import {Reservation} from "./reservation";
import {Credit} from "./credit";
import {GuestCredit} from "./guest-credit";
import {Agency} from "./agency";
import {TravelCreditBatch} from "./travel-credit-batch";
import {AuditableTravelCreditBatch} from "./auditable-travel-credit-batch";
import {BrokenRule} from "./broken-rule";
import {AuditableTravelCredit} from "./auditable-travel-credit";
import {AuditableTravelCredits} from "./auditable-travel-credits";

export class TravelCredit {

  constructor(public id: number = 0,
              public creditCode: string = null,
              public travelCreditType: TravelCreditType = null,
              public pnr: string = null,
              public ticketNumber: string = null,
              public guestFirstName: string = null,
              public guestLastName: string = null,
              public wviBookingId: string = null,
              public iata: Iata = null,
              public travelAgencyName: string = null,
              public travelAgentName: string = null,
              public reasonCode: ReasonCode = null,
              public refundReason: RefundReason = null,
              public fareMasked: boolean = null,
              public feeAmountWaived: number = null,
              public valueWaived: number = null,
              public currency: Currency = null,
              public comments: string = null,
              public salesRep: string = null,
              public team: Team = null,
              public createdBy: string = null,
              public createdDate: Date = null,
              public updatedBy: string = null,
              public updatedDate: Date = null) { }

  static createFrom(reservation: Reservation, credit: Credit, guestCredit: GuestCredit, agency: Agency, iata: Iata, id: number = 0) {
    return new TravelCredit(id, null, credit.travelCreditType, reservation.pnr,
      guestCredit.ticketNumber, guestCredit.guestFirstName, guestCredit.guestLastName, reservation.wviBookingId,
      iata, agency.travelAgencyName, agency.travelAgentName, credit.reasonCode, credit.refundReason, credit.fareMasked,
      parseFloat(guestCredit.feeAmountWaived), parseFloat(guestCredit.valueWaived), credit.currency, agency.comments,
      agency.salesRep, agency.team, null, null, null, null);
  }

  static parseCreateTravelCreditJson(travelCreditsList: Array<TravelCredit>) {
    return JSON.stringify({
      'travelCredits': travelCreditsList
    });
  }

  static parseUpdateTravelCreditJson(travelCredit: TravelCredit) {
    return JSON.stringify({
      'travelCredit': travelCredit
    });
  }

  static parseTravelCreditBatchResponse(jsonResult: any) {
    let travelCredits = [];
    let  totalTravelCredits = 0;
    let travelCreditBatch: TravelCreditBatch;
    let success = jsonResult.wasSuccessful;
    let brokenRules = jsonResult.brokenRules.map(response => Object.assign(new BrokenRule, {
      message: response.message,
    }));

    if (success) {
      travelCredits = jsonResult.travelCredits.map(response => Object.assign(new TravelCredit, {
        id: response.id,
        creditCode: response.creditCode,
        travelCreditType: response.travelCreditType,
        pnr: response.pnr,
        ticketNumber: response.ticketNumber,
        guestFirstName: response.guestFirstName,
        guestLastName: response.guestLastName,
        wviBookingId: response.wviBookingId,
        iata: response.iata,
        travelAgencyName: response.travelAgencyName,
        travelAgentName: response.travelAgentName,
        reasonCode: response.reasonCode,
        refundReason: response.refundReason,
        fareMasked: response.fareMasked,
        feeAmountWaived: response.feeAmountWaived,
        valueWaived: response.valueWaived,
        currency: response.currency,
        comments: response.comments,
        salesRep: response.salesRep,
        team: response.team,
        createdBy: response.createdBy,
        createdDate: response.createdDate,
        updatedBy: response.updatedBy,
        updatedDate: response.updatedDate
      }));

      totalTravelCredits = jsonResult.totalTravelCredits;
      travelCreditBatch = new TravelCreditBatch(travelCredits, totalTravelCredits);
    }

    return new AuditableTravelCreditBatch(travelCreditBatch, brokenRules);
  }

  static parseTravelCreditResponse(json: Object) {
    let success = json['wasSuccessful'];
    let brokenRules: Array<BrokenRule> = null;

    if (!success) {
      brokenRules = json["brokenRules"].map(r => Object.assign(new BrokenRule(), {
        message: r.message
      }));
      return new AuditableTravelCredit(null, brokenRules);
    }

    let result = new TravelCredit(
      json["travelCredit"].id,
      json["travelCredit"].creditCode,
      json["travelCredit"].travelCreditType,
      json["travelCredit"].pnr,
      json["travelCredit"].ticketNumber,
      json["travelCredit"].guestFirstName,
      json["travelCredit"].guestLastName,
      json["travelCredit"].wviBookingId,
      json["travelCredit"].iata,
      json["travelCredit"].travelAgencyName,
      json["travelCredit"].travelAgentName,
      json["travelCredit"].reasonCode,
      json["travelCredit"].refundReason,
      json["travelCredit"].fareMasked,
      json["travelCredit"].feeAmountWaived,
      json["travelCredit"].valueWaived,
      json["travelCredit"].currency,
      json["travelCredit"].comments,
      json["travelCredit"].salesRep,
      json["travelCredit"].team,
      json["travelCredit"].createdBy,
      json["travelCredit"].createdDate,
      json["travelCredit"].updatedBy,
      json["travelCredit"].updatedDate
    );

    return new AuditableTravelCredit(result, brokenRules);
  }

  static parseTravelCreditsResponse(jsonArray: Array<Object>) {
    var objects = [];
    var success = jsonArray['wasSuccessful'];
    var brokenRules = jsonArray["brokenRules"].map(response => Object.assign(new BrokenRule, {
      message: response.message,
    }));

    if (success)
      objects = jsonArray["travelCredits"].map(response => Object.assign(new TravelCredit, {
        id: response.id,
        creditCode: response.creditCode,
        travelCreditType: response.travelCreditType,
        pnr: response.pnr,
        ticketNumber: response.ticketNumber,
        guestFirstName: response.guestFirstName,
        guestLastName: response.guestLastName,
        wviBookingId: response.wviBookingId,
        iata: response.iata,
        travelAgencyName: response.travelAgencyName,
        travelAgentName: response.travelAgentName,
        reasonCode: response.reasonCode,
        refundReason: response.refundReason,
        fareMasked: response.fareMasked,
        feeAmountWaived: response.feeAmountWaived,
        valueWaived: response.valueWaived,
        currency: response.currency,
        comments: response.comments,
        salesRep: response.salesRep,
        team: response.team,
        createdBy: response.createdBy,
        createdDate: response.createdDate,
        updatedBy: response.updatedBy,
        updatedDate: response.updatedDate
      }));

    return new AuditableTravelCredits(objects, brokenRules);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/travel-credit.ts